import React, { useState } from 'react';

import ACHForm from './ACHForm';

import { PaymentProps, BaseAchProps } from './shared';
import { FundingAccountState } from '../shared';

import css from '../FundingAccount.module.scss';

export interface AchProps extends BaseAchProps {
  invalidAmountError: boolean;
  isMorganStanleyFlow?: boolean;
  handlePayment: (props: PaymentProps) => void;
  createErrorDispatch: (msg: string) => void;
  getBankNameDispatch: (routing: string) => void;
  setFundingSource: (type: string | null) => void;
}

export default function ManualACH({
  fundingSource,
  invalidAmountError,
  isMorganStanleyFlow,
  handlePayment,
  createErrorDispatch,
  getBankNameDispatch,
  setFundingSource
}: AchProps) {
  const [achError, setAchError] = useState(false);

  const saveAchAccount = ({
    radioSelected,
    achName,
    routingNumber,
    accountNumber,
    validateAccountNumber
  }: FundingAccountState) => {
    if (
      radioSelected &&
      achName &&
      routingNumber &&
      accountNumber &&
      validateAccountNumber === accountNumber
    ) {
      if (routingNumber.length !== 9) {
        setAchError(true);
        createErrorDispatch('Please enter a valid routing number.');
      } else {
        setAchError(false);
        handlePayment({
          accountNumber,
          routingNumber,
          nameOnAccount: achName,
          accountType: radioSelected
        });
      }
    } else {
      setAchError(true);
      createErrorDispatch('Please ensure all fields are filled out properly.');
    }
  };

  const toggleForm = () => {
    if (fundingSource === 'ach') {
      setFundingSource(null);
    } else {
      setFundingSource('ach');
    }
  };

  const isFormVisible = fundingSource === 'ach';

  return (
    <div
      className={`${!isFormVisible ? css.AddFundingAccountUnselected : ''} 
      ${css.AddFundingAccountSecondary} 
      ${
        isMorganStanleyFlow
          ? `${css.MSFundingContainer} ${css.noTopSpacing}`
          : css.AddFundingAccountContainer
      }
      `}
      data-e2e="manual-ach"
    >
      <div className={css.ManualAchContainer}>
        {!isMorganStanleyFlow && (
          <div
            className={css.ManualAchWrapper}
            onClick={toggleForm}
            data-testid="manual-ach-form"
          >
            <div className={css.AddFundingAccountItemText}>
              <p className={css.AddFundingAccountItemHeader}>
                {!isFormVisible
                  ? 'Add a bank manually'
                  : 'Add your personal bank account manually'}
              </p>
              <p className={css.AddFundingAccountItemSubheader}>
                Use routing number and account number to connect*
              </p>
            </div>
            <div
              className={`${css.manualACHButton} ${
                isFormVisible ? css.rotated : ''
              }`}
            >
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1L5 5L1 9"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        )}
        {isFormVisible && (
          <ACHForm
            error={achError}
            invalidAmountError={invalidAmountError}
            fundingSource={fundingSource}
            saveAchAccount={saveAchAccount}
            getBankNameDispatch={getBankNameDispatch}
            isMorganStanleyFlow={isMorganStanleyFlow}
          />
        )}
      </div>
    </div>
  );
}
